<template>
    <v-container fluid>
        <v-row justify="center">
            <v-card width="90%" class="mt-5" elevation="0">
                <v-card-title class="text-h5" style="background-color: #f4f4f5 !important">
                    <v-img :src="require('../../assets/clientpage.svg')" class="mr-3" contain max-width="35"
                        max-height="35" />
                    <strong style="font-size:26px;">Blog</strong>
                    <v-spacer />
                    <v-btn text color="#172C54" class="mr-2" style="text-transform: none !important"
                        :href="site_url + '/blog/'" target="_blank">
                        View blog <v-icon small class="ml-1">mdi-open-in-new</v-icon>
                    </v-btn>
                    <v-btn dark color="#172C54" style="height:40px;text-transform: none !important"
                        @click="$router.push({ name: '/admin_blog_new' })">
                        New post <v-icon class="ml-2">mdi-plus</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-title class="text-small pb-0" style="background-color: #f4f4f5 !important;height:70px">
                    <small style="position: relative; top: -10px; font-size:12px;">
                        {{ published_count }} published, {{ posts.length - published_count }} draft.
                        Posts appear on myfarewellwishes.ie/blog as soon as they are published.
                    </small>
                </v-card-title>
            </v-card>
            <v-card width="90%" style="border-radius: 16px" elevation="0">
                <v-card-text class="mt-5">
                    <v-data-table :headers="headers" :items="posts" :items-per-page="20" :loading="loading"
                        :mobile-breakpoint="600" class="blog_table" @click:row="openPost">
                        <template v-slot:[`item.featured_image`]="{ item }">
                            <v-img v-if="item.featured_image" :src="item.featured_image" width="90" height="50"
                                class="my-2" style="border-radius: 6px" />
                        </template>
                        <template v-slot:[`item.title`]="{ item }">
                            <strong>{{ item.title }}</strong>
                            <div style="font-size:12px;color:#888">/blog/{{ item.slug }}/</div>
                        </template>
                        <template v-slot:[`item.status`]="{ item }">
                            <v-chip small :color="item.status == 'published' ? 'green' : 'grey'" dark>
                                {{ item.status == 'published' ? 'Published' : 'Draft' }}
                            </v-chip>
                        </template>
                        <template v-slot:[`item.published_at`]="{ item }">
                            {{ item.published_at ? $date(item.published_at).format('D MMM YYYY') : '-' }}
                        </template>
                        <template v-slot:[`item.updated_at`]="{ item }">
                            {{ $date(item.updated_at).format('D MMM YYYY HH:mm') }}
                        </template>
                        <template v-slot:[`item.actions`]="{ item }">
                            <v-btn v-if="item.status == 'published'" icon :href="item.url" target="_blank" @click.stop>
                                <v-icon small>mdi-open-in-new</v-icon>
                            </v-btn>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-row>
    </v-container>
</template>

<script>
export default {
    data: () => ({
        site_url: 'https://myfarewellwishes.ie',
        posts: [],
        loading: false,
        headers: [
            { text: '', value: 'featured_image', sortable: false, width: 110 },
            { text: 'Title', value: 'title' },
            { text: 'Status', value: 'status' },
            { text: 'Published', value: 'published_at' },
            { text: 'Last edited', value: 'updated_at' },
            { text: '', value: 'actions', sortable: false },
        ],
    }),
    mounted() {
        this.getPosts()
    },
    computed: {
        published_count() {
            return this.posts.filter(p => p.status == 'published').length
        },
    },
    methods: {
        async getPosts() {
            this.loading = true
            const { data } = await this.$axios.get('auth/admin/blog/posts')
            this.loading = false
            if (data && data.response) {
                this.posts = data.data
            } else {
                this.$store.commit('auth/setMessage', { show: true, message: (data && data.message) || 'Could not load posts' }, { root: 1 })
            }
        },
        openPost(item) {
            this.$router.push({ name: '/admin_blog_edit', params: { id: item.id } })
        },
    },
}
</script>

<style scoped>
.blog_table ::v-deep tbody tr {
    cursor: pointer;
}
</style>
